import _defineProperty from '@babel/runtime-corejs2/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs2/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import Tooltip from '@locus-labs/mol-desktop-tooltip';
import MapNavButton from '@locus-labs/mol-desktop-map-nav-button';
import PropTypes from 'prop-types';
import styledSystemPropTypes from '@styled-system/prop-types';
import { jsx } from 'react/jsx-runtime';

const _excluded = ["onCompassClick", "tooltipContent", "tooltipZIndex"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const Compass = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      onCompassClick,
      tooltipContent,
      tooltipZIndex
    } = props,
    omittedProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/jsx(Tooltip, {
    content: tooltipContent,
    tooltipZIndex: tooltipZIndex,
    children: /*#__PURE__*/jsx(MapNavButton, _objectSpread({
      iconName: "compass.color",
      ref: ref,
      degreesOfIconRotation: props.bearing ? props.bearing * -1 : 0,
      onClick: onCompassClick,
      ariaLabel: props.tooltipContent
    }, omittedProps))
  });
});
Compass.displayName = 'Compass';
Compass.defaultProps = {
  'data-cy': 'Compass',
  tooltipContent: 'Reset Map Rotation' // component name
};
Compass.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styledSystemPropTypes.space), styledSystemPropTypes.color), styledSystemPropTypes.background), styledSystemPropTypes.border), styledSystemPropTypes.flexbox), styledSystemPropTypes.grid), styledSystemPropTypes.layout), styledSystemPropTypes.position), styledSystemPropTypes.shadow), styledSystemPropTypes.typography), {}, {
  as: PropTypes.string,
  forwardAs: PropTypes.string,
  onCompassClick: PropTypes.func.isRequired,
  bearing: PropTypes.number,
  tooltipContent: PropTypes.string,
  tooltipZIndex: PropTypes.number
});

export default Compass;
